//#region src/transaction_result.ts
var TransactionResult = /* @__PURE__ */ function(TransactionResult) {
	TransactionResult[TransactionResult["None"] = 0] = "None";
	TransactionResult[TransactionResult["Approved"] = 1] = "Approved";
	TransactionResult[TransactionResult["PartiallyApproved"] = 2] = "PartiallyApproved";
	TransactionResult[TransactionResult["Declined"] = 3] = "Declined";
	TransactionResult[TransactionResult["OfflineApproved"] = 4] = "OfflineApproved";
	return TransactionResult;
}(TransactionResult || {});
//#endregion
export { TransactionResult };

//# sourceMappingURL=transaction_result.js.map